// Шелл застосунку: сайдбар (lg+) / висувне меню (мобільні від 360 px), топбар, область сторінки.
import { X } from 'lucide-react';
import { Suspense, useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { LoadingBlock, Portal, useFocusTrap, useScrollLock } from '@/ui';
import { Sidebar, SidebarContent } from './Sidebar';
import { Topbar } from './Topbar';

function MobileNav({ open, onClose }: { open: boolean; onClose: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useScrollLock(open);
  useFocusTrap(ref, open);
  if (!open) return null;
  return (
    <Portal>
      <div
        className="fixed inset-0 z-50 flex bg-overlay animate-fade-in lg:hidden"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div
          ref={ref}
          role="dialog"
          aria-modal="true"
          aria-label="Меню"
          tabIndex={-1}
          onKeyDown={(e) => {
            if (e.key === 'Escape') onClose();
          }}
          className="relative h-full w-[280px] max-w-[85vw] animate-slide-in-left"
        >
          <SidebarContent onNavigate={onClose} />
          <button
            type="button"
            onClick={onClose}
            data-close-button="true"
            className="absolute top-4 right-3 flex size-8 items-center justify-center rounded-field text-nav-muted hover:bg-nav-hover hover:text-nav-fg"
            aria-label="Закрити меню"
          >
            <X className="size-[18px]" />
          </button>
        </div>
      </div>
    </Portal>
  );
}

export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Закрити мобільне меню при переході.
  useEffect(() => setMenuOpen(false), [pathname]);

  return (
    <div className="flex min-h-dvh bg-bg">
      <a
        href="#main"
        className="sr-only z-[80] rounded-field bg-primary-solid px-3 py-2 text-on-primary-solid focus:not-sr-only focus:fixed focus:top-2 focus:left-2"
      >
        Перейти до вмісту
      </a>
      <Sidebar />
      <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onOpenMenu={() => setMenuOpen(true)} />
        <main id="main" className="min-w-0 flex-1 px-3 py-4 sm:px-6 sm:py-6">
          <Suspense fallback={<LoadingBlock />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
